import { useState, useEffect } from 'react';
import { geStatistikaDolaska } from '../../util/apiMigracija';
import { Box, useToast, Stat,
    StatLabel,
    StatNumber,
    StatArrow,
    StatGroup, } from '@chakra-ui/react';

export default function DolazakStatistika({migracijaid=0}) {
    const [state,setState]=useState({ukgov:0,nafarmi:0,prodaja:0,klaonica:0, uginuce:0, ostalo:0});
    const toast=useToast();

    
    useEffect(() => {
        const fetchData=async()=>{
        try {
            
            const res=await geStatistikaDolaska(migracijaid);
            if (res.status===200) {
                let br=0;
                let nafarmi=0;
                let prodaja=0;
                let klaonica=0;
                let uginuce=0;
                let ostalo=0;
                res.res.forEach((item)=>{
                    br+=parseInt(item.br);
                    switch (item.migracija_vrsta_id) {
                        case -1:
                           nafarmi=item.br; 
                            break;
                        case 1:
                           prodaja=item.br; 
                            break;
                        case 2:
                            klaonica=item.br; 
                            break;
                        case 3:
                            uginuce=item.br; 
                            break;
                        case 4:
                            ostalo=item.br; 
                            break;
                        default:
                            break;
                    }
                });
                setState({...state,ukgov:br,nafarmi:nafarmi,prodaja:prodaja,uginuce:uginuce,ostalo:ostalo, klaonica:klaonica});
                
                
                
            } else {
                throw new Error(res.message);
            }
            
        } catch (error) {
            toast({
                title:"Greška kod dohvata podataka (unos migracije).",
                status:"error",
                description:error.message,
                isClosable:true,
                duration:2000,
                position:"top-right",
            });
        
    }
    }
      fetchData();
    
      
    }, [migracijaid,state,toast])
    

  return (
    <Box>
        <StatGroup>
            <Stat size={'xs'}>
                <StatLabel>Goveda na farmi</StatLabel>
                <StatNumber>{state.nafarmi}</StatNumber>
                <StatArrow type='increase'/>
            </Stat>
        </StatGroup>
        <StatGroup>
            <Stat size={'xs'}>
                <StatLabel>Prodaja</StatLabel>
                <StatNumber>{state.prodaja}</StatNumber>
                <StatArrow type='decrease'/>
            </Stat>
            <Stat size={'xs'}>
                <StatLabel>Klaonica</StatLabel>
                <StatNumber>{state.klaonica}</StatNumber>
                <StatArrow type='decrease'/>
            </Stat>
        </StatGroup>
        <StatGroup>
        <Stat size={'xs'}>
                <StatLabel>Uginuće</StatLabel>
                <StatNumber>{state.uginuce}</StatNumber>
                <StatArrow type='decrease'/>
            </Stat>
            <Stat size={'xs'}>
                <StatLabel>Ostalo</StatLabel>
                <StatNumber>{state.ostalo}</StatNumber>
                <StatArrow type='decrease'/>
            </Stat>
        </StatGroup>
    </Box>
  )
}
